<template>
  <div class="resource-box">
    <div class="item">
      <p class="res-title">{{ $t('resource') }}</p>
      <el-select
        v-model="resourceType"
        :popper-class="disabledEdit ? 'is-readonly' : ''"
        :class="{'is-readonly': disabledEdit}"
        size="small"
        placeholder=""
        @change="setDefalutResource()"
        filterable>
        <el-option
          v-for="item in resouceTypeList"
          :key="item.value"
          :label="$t(`${item.label}`)"
          :value="item.value"
          :disabled="disabledEdit">
          <i class="iconfont m-r-10 fontNormal"
             :class="item.icon"></i>
          <span>{{ $t(`${item.label}`)}}</span>
        </el-option>
      </el-select>
    </div>
    <div class="item"
         v-show="resourceType == 'boxPool'">
      <p class="res-title">{{ $t('boxPool') }}<i class="iconfont icon-resource"></i></p>
      <el-select
        v-model="boxId"
        :disabled="boxLoading"
        :popper-class="disabledEdit ? 'is-readonly' : ''"
        :class="{'is-readonly': disabledEdit}"
        size="small"
        placeholder=""
        @change="setDefalutResource()"
        filterable>
        <el-option v-for="item in boxList"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id"
                   :disabled="disabledEdit">
          <div class="box-item">
            <span class="box-name">{{ item.name }}</span>
            <span>{{ item.activeCount }}</span>
            <span>
              <i class="box-active">{{ item.utilization ? item.utilization.usedScore : 0 }}</i>
              <i>/</i>
              <i>{{ item.utilization ? item.utilization.totalScore : 0 }}</i>
            </span>
          </div>
        </el-option>
      </el-select>
      <div class="byor-content"
           v-html="$t('manageBoxPool', {
             url: initConfig.homeUrl})"></div>
    </div>
    <div class="item"
         v-show="resourceType == 'TVU'">
      <p class="res-title">{{ $t('tvuHostedServerLocation') }} <i class="iconfont icon-a-cloudresource"></i><span class="f12">{{(regionList[0] && regionList[0].abbreviation) || ''}}</span></p>
      <el-select v-model="tvuRegion"
                 ref="regionSelect"
                 filterable
                 @change="changeValue()"
                 :popper-class="disabledEdit ? 'tvu-region-select is-readonly' : 'tvu-region-select'"
                 :class="{'is-readonly': disabledEdit}"
                 placeholder="Please select"
                 @visible-change="(visible) => { if (!visible) hoveredRegion = '' }">
        <el-option
          v-for="item in regionList"
          :key="item.tvuRegion"
          :label="`${item.tvuRegion} (Estimated startup time: ${item.costTimeT})`"
          :value="item.tvuRegion"
          :disabled="disabledEdit">
          <div class="region-item"
               @mouseenter="showMarker(item)"
               @mouseleave="hoveredRegion = ''"
               :title="`${item.tvuRegion} (Estimated startup time: ${item.costTimeT})`">
            {{ item.tvuRegion }} <span class="f12">(Estimated startup time: {{item.costTimeT}})</span>
          </div>
        </el-option>
        <div class="map-item">
          <div class="map-container">
            <div class="dot-world-map">
              <img src="@/assets/img/map.png"
                   alt="World Map" />
              <!-- 遍历所有有经纬度的 region，在地图上展示可点击的标记点 [Claude Code] -->
              <el-tooltip
                v-for="item in markableRegions"
                :key="'marker-' + item.tvuRegion"
                :content="item.tvuRegion"
                placement="top"
                effect="dark">
                <div
                  class="region-marker"
                  :class="{
                    'marker-active': item.tvuRegion === tvuRegion,
                    'marker-hover': item.tvuRegion === hoveredRegion && item.tvuRegion !== tvuRegion
                  }"
                  :style="latLngToSvgCoordinate(item.latitude, item.longitude)"
                  @click.stop="selectRegionFromMap(item)"
                ></div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </el-select>
    </div>
    <div class="item"
         v-if="showStaticIpBlock">
      <p class="res-title ip-title">{{ $t('staticIp') }}
        <el-switch style="margin-left: 10px;"
                   v-model="ipLabel"
                   active-color="#2FB54E"
                   inactive-color="#595959"
                   :active-value="1"
                   :inactive-value="0"
                   @change="changeValue()">
        </el-switch>
        <span class="static-ip"
              v-html="$t('manageStaticIP', { url: initConfig.homeUrl + '?activeName=ElasticIP' })"></span>
      </p>
      <div class="ip-wrap"
           v-if="ipLabel == 1">
        <el-select
          v-model="staticIP"
          :popper-class="disabledEdit ? 'ip_select is-readonly' : 'ip_select'"
          :class="{'is-readonly': disabledEdit}"
          :disabled="adminInfo.staticIp === '0'"
          filterable
          clearable
          @change="changeValue()"
          size="small"
          class="region-select"
          :placeholder="$t('optional')">
          <el-option
            v-for="item in ipList"
            :key="item.elasticIp"
            :label="item.elasticIp"
            :value="item.elasticIp"
            :disabled="!(item.status == 0 || item.bindId === objectId) || disabledEdit">
            <div class="ip-item">
              <el-tooltip class="item"
                          effect="dark"
                          :disabled="item.status == 0 || item.bindId === objectId"
                          :content="`Occupied by ${item.name}`"
                          placement="right">
                <span class="elastic-ip"
                      :class="{ 'no-use': item.status == 0, 'diable-use': item.status != 0, 'own-use': item.status != 0 && item.bindId === objectId }">{{
                        item.elasticIp }}</span>
              </el-tooltip>
            </div>
          </el-option>
        </el-select>
        <span class="iconfont icon-Copy"
              :class="{'diable-use': !staticIP }"
              @click="copyUrl(staticIP)"></span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getPhysicalList, getTvuRegionList, getStaticIP, getTvuRegionByRegion } from '@/axios/mediaHub.js'
import { setMHUserBehavior, getMHUserBehavior } from '@/axios/operateCenter'
import Tool from '@/assets/js/utils'
export default {
  props: {
    objectId: {
      type: String,
      default: ''
    },
    staticIpInfo: {
      type: String,
      default: ''
    },
    regionInfo: {
      type: String,
      default: '' // 历史数据的region
    },
    tvuRegionInfo: {
      type: String,
      default: '' // tvu region
    },
    boxIdInfo: {
      type: String,
      default: ''
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    showStaticIp: {
      type: Boolean,
      default: false
    },
    origin: {
      type: String,
      default: ''
    },
    // 外部强制指定 resource 下拉的初始值，取值 '' | 'TVU' | 'boxPool' [Claude Code]
    // 使用场景：资源不足通知（InsufficientResources）跳转到 resources tab 时，强制默认展示 TVU-Hosted [Claude Code]
    // 仅作用于 getConfigInfo / getDefalutResource 两个初始化决策点；用户后续手动切换不受影响 [Claude Code]
    forceResourceType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      regionList: [],
      tvuRegion: '',
      boxId: '',
      boxList: [],
      boxLoading: true,
      resourceType: 'TVU',
      resouceTypeList: [{
        label: 'tvuRes',
        value: 'TVU',
        icon: 'icon-a-cloudresource'
      }, {
        label: 'selfHost',
        value: 'boxPool',
        icon: 'icon-resource'
      }],
      ipLabel: 0,
      staticIP: '',
      ipList: [],
      hoveredRegion: '' // 当前 hover 的 region tvuRegion 值 [Claude Code]
    }
  },
  computed: {
    ...mapState({
      defaultRegionRemapping: 'defaultRegionRemapping',
      defaultAdminConfig: 'defaultAdminConfig',
      initConfig: 'initConfig',
      adminInfo: 'adminInfo'
    }),
    // 过滤出有经纬度的 region 列表，用于地图标记渲染 [Claude Code]
    markableRegions () {
      return this.regionList.filter(r => r.latitude && r.longitude)
    },
    showStaticIpBlock () {
      // remark 代表 vendor 是否支持 staticip
      return !!(this.showStaticIp && this.resourceType === 'TVU' && (this.adminInfo.staticIp === '1' || !!this.staticIP) && this.regionList[0] && !this.regionList[0].remark)
    },
    defaultTvuRegion () {
      return this.defaultRegionRemapping.tvuRegion
    }
  },
  watch: {
    resourceType: {
      handler (val) {
        this.$store.commit('changeResourceGlobalConfig', val)
      },
      immediate: true
    },
    staticIpInfo (val) {
      if (this.objectId) {
        this.getConfigInfo()
      }
    },
    regionInfo (val) {
      if (this.objectId) {
        this.getConfigInfo()
      }
    },
    tvuRegionInfo (val) {
      if (this.objectId) {
        this.getConfigInfo()
      }
    },
    boxIdInfo (val) {
      if (this.objectId) {
        this.getConfigInfo()
      }
    },
    showStaticIp (val) {
      if (val) {
        this.getStaticIPListFn()
      }
    },
    ipLabel (val) {
      if (val == 1) {
        this.getStaticIPListFn()
      }
    },
    tvuRegion (val) {
      if (val && this.ipLabel == 1) {
        this.getStaticIPListFn(this.changeValue)
      }
      this.setDefalutResource()
    }
  },
  async created () {
    let callback = null
    if (this.objectId) {
      callback = (originRegion, originBoxId) => {
        this.getConfigInfo(originRegion, originBoxId)
      }
    }
    await this.getDefalutResource(callback)
    this.getRegionListFn()
    this.getPhysicalListFn()
    this.getStaticIPListFn()
    this.changeValue()
  },
  methods: {
    async getTvuRegionByRegionFn () {
      await getTvuRegionByRegion(this.regionInfo).then(res => {
        if (res.errorCode == '0x0') {
          this.tvuRegion = res.result.tvuRegion
        }
      }).catch(() => {})
    },
    async getConfigInfo (originRegion, originBoxId) {
      // console.info(21688, originRegion, originBoxId, this.tvuRegionInfo, this.regionInfo)
      this.boxId = this.boxIdInfo
      this.staticIP = this.staticIpInfo
      this.staticIP && (this.ipLabel = 1)
      if (this.regionInfo && !this.tvuRegionInfo) {
        await this.getTvuRegionByRegionFn()
      }
      // if (this.tvuRegionInfo) {
      this.tvuRegion = this.tvuRegionInfo || this.tvuRegion || this.defaultTvuRegion
      // } else if (this.regionInfo) {
      //   // 获取映射关系的tvuRegion
      //   if (!this.regionList.length) {
      //     await this.getRegionListFn()
      //   }
      //   const idx = this.regionList.findIndex(k => k.region === this.regionInfo)
      //   if (idx > -1) {
      //     this.tvuRegion = this.regionList[idx].tvuRegion || this.defaultTvuRegion
      //     this.showMarker(this.regionList[idx])
      //   } else {
      //     this.tvuRegion = this.defaultTvuRegion
      //   }
      // } else {
      //   this.tvuRegion = this.defaultTvuRegion
      // }
      // forceResourceType 最高优先级：用于资源不足通知跳转等场景强制初始值 [Claude Code]
      // 保留 boxId / tvuRegion 原值，用户后续手动切到 Self Host 仍可用 [Claude Code]
      if (this.forceResourceType) {
        this.resourceType = this.forceResourceType
      } else if (this.boxId) {
        this.resourceType = 'boxPool'
        if (originRegion) {
          this.tvuRegion = originRegion
        }
      } else {
        this.resourceType = 'TVU'
        if (originBoxId) {
          this.boxId = originBoxId
        }
      }
    },
    changeValue () {
      this.$emit('callback', {
        tvuRegion: this.tvuRegion,
        boxId: this.boxId,
        resourceType: this.resourceType,
        staticIP: this.ipLabel == 1 ? this.staticIP : ''
      })
    },
    copyUrl (str) {
      if (!str) return
      Tool.copyText(str, () => {
        this.$MHNotify({ title: 'Success', type: 'success', message: this.$t('copyS') })
      })
    },
    getStaticIPListFn (callback) {
      const tvuRegion = this.tvuRegion || this.defaultTvuRegion
      if (!this.showStaticIp || this.ipLabel != 1) return
      this.staticIP = ''
      // console.info(111111111111, this.tvuRegion, this.defaultTvuRegion)
      getStaticIP(tvuRegion).then(res => {
        if (res.errorCode == '0x0') {
          const result = res.result || []
          const staticIP = this.staticIpInfo || ''
          const idx = result.findIndex(k => k.elasticIp === staticIP)
          if (idx > -1) {
            this.staticIP = result[idx].bindId === this.objectId ? staticIP : ''
          } else {
            this.staticIP = ''
          }
          this.staticIP && (this.ipLabel = 1)
          this.ipList = result
          // console.info(31223, this.ipLabel, this.staticIP, this.staticIpInfo)

          typeof callback === 'function' && callback()
        }
      }).catch(() => { })
    },
    getPhysicalListFn () {
      this.boxLoading = true
      getPhysicalList().then(res => {
        this.boxLoading = false
        if (res.errorCode == '0x0') {
          this.boxList = res.result.list || []
          const boxId = this.boxList[0] ? this.boxList[0].id : ''
          this.boxId = this.boxId ? this.boxId : boxId
        }
      }).catch(() => { })
    },
    // 获取regionList
    async getRegionListFn () {
      await getTvuRegionList({
        tvuVendor: this.adminInfo.tvuVendor
      }).then(res => {
        if (res.errorCode == '0x0') {
          // console.info(21688, this.$options)
          const list = res.result || []
          this.regionList = list.map(v => {
            return {
              ...v,
              costTimeT: this.$options.filters.FORMATSTARTUPTIME(v.costTime)
            }
          })
        }
      }).catch(() => { })
    },
    setDefalutResource (value) {
      if (this.origin == 'global') {
        const params = {
          tvuRegion: this.resourceType == 'boxPool' ? '' : this.tvuRegion,
          boxId: this.resourceType == 'boxPool' ? this.boxId : '',
          resourceType: this.resourceType
        }
        this.setUserBehavior(params)
      } else {
        if (value && this.showStaticIp && this.ipLabel == 1) {
          this.getStaticIPListFn(this.changeValue)
        } else {
          this.changeValue()
        }
      }
    },
    async getDefalutResource (callback) {
      await getMHUserBehavior({
        pn: 'mediahub',
        key: 'GlobalRegionConfig'
      }).then(res => {
        if (res.errorCode == '0x0') {
          const result = JSON.parse(res.result) || {}
          const tvuRegion = result.tvuRegion || this.defaultTvuRegion
          const boxId = result.boxId || ''
          if (typeof callback !== 'function') {
            this.tvuRegion = tvuRegion
            this.boxId = boxId
            // forceResourceType 最高优先级，兜底仍走用户行为配置 / boxId 判定 [Claude Code]
            this.resourceType = this.forceResourceType || result.resourceType || (this.boxId ? 'boxPool' : 'TVU')
          } else {
            callback(tvuRegion, boxId)
          }
        }
      }).catch(() => { })
    },
    setUserBehavior (value) {
      setMHUserBehavior({
        pn: 'mediahub',
        content: JSON.stringify(value),
        key: 'GlobalRegionConfig',
        type: 1
      }).then(() => { }).catch(() => { })
    },
    // 设置当前 hover 的 region [Claude Code]
    showMarker (regionInfo) {
      if (!regionInfo || !regionInfo.tvuRegion) return
      this.hoveredRegion = regionInfo.tvuRegion
    },
    // 点击地图标记点选择 region，等同于下拉选择行为 (MH-2451) [Claude Code]
    selectRegionFromMap (regionInfo) {
      if (!regionInfo || !regionInfo.tvuRegion) return
      this.tvuRegion = regionInfo.tvuRegion
      this.changeValue()
      // 关闭下拉面板 [Claude Code]
      this.$refs.regionSelect && this.$refs.regionSelect.blur()
    },
    // 将经纬度转换为SVG地图坐标
    latLngToSvgCoordinate (latitude, longitude) {
      // SVG地图尺寸
      const svgWidth = 400
      const svgHeight = 200

      // 经纬度范围
      const minLon = -180
      const maxLon = 180
      const minLat = -90
      const maxLat = 90

      // 计算坐标（经纬度转SVG坐标）
      // 经度转换为X坐标：-180°对应0，180°对应svgWidth
      const x = ((longitude - minLon) / (maxLon - minLon)) * svgWidth
      // 纬度转换为Y坐标：90°对应0，-90°对应svgHeight（注意Y轴方向相反）
      const y = ((maxLat - latitude) / (maxLat - minLat)) * svgHeight

      // 返回CSS样式对象
      return {
        left: `${x}px`,
        top: `${y}px`
      }
    }
  }
}
</script>
<style lang="less" scoped>
a {
  font-weight: bold;
  color: @green;
  text-decoration: none;
}
.resource-box {
  text-align: left;

  .item {
    margin-top: 10px;

    .res-title {
      color: #9e9e9e;
      margin-bottom: 8px;
      font-weight: 400;
      .f12 {
        font-size: 12px;
        color: #595959;
      }
      .iconfont {
        font-size: 16px;
        color: #f8f8f8;
        margin: 0 5px;
      }
    }

    .ip-title {
      display: flex;
      align-items: center;
      position: relative;

      .static-ip {
        position: absolute;
        right: 0;
      }
    }

    .icon-info {
      margin-left: 5px;
    }

    .icon-Copy {
      margin-left: 10px;
      color: #dbdbdb;
      cursor: pointer;

      &.diable-use {
        color: #595959;
        cursor: not-allowed;
      }
    }

    .region-user {
      display: flex;
      align-items: center;
    }

    .byor-content {
      margin-top: 5px;
      color: #ddd;
      a {
        color: @green;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .ip-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  :deep(a) {
    color: @green;
    font-weight: bold;
  }

  .el-select {
    width: 100%;
  }
}

.map-container {
    width: 420px;
    height: 230px;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #353535;
    .dot-world-map {
      margin-top: 35px;
      width: 400px;
      height: 200px;
      position: relative;
      // overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      // background-color: #353535;
      position: relative;
      img {
        width: 100%;
        // height: 100%;
        // object-fit: contain;
        position: absolute;
        top: -25px;
        left: 10px;
      }

      // 地图标记点基础样式，默认绿色小圆 7px，可点击选择 region (MH-2451) [Claude Code]
      .region-marker {
        position: absolute;
        width: 7px;
        height: 7px;
        background-color: #2FB54E;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        // 扩大点击热区，方便用户点击小圆点 [Claude Code]
        &::after {
          content: '';
          position: absolute;
          top: -8px;
          left: -8px;
          right: -8px;
          bottom: -8px;
        }
      }

      // hover 标记点：绿色大圆 10px + 白色边框 [Claude Code]
      .marker-hover {
        width: 10px;
        height: 10px;
        border: 2px solid #FFFFFF;
      }

      // 选中标记点：绿色 + 脉冲动画 [Claude Code]
      .marker-active {
        width: 12px;
        height: 12px;
        border: 2px solid #FFFFFF;
        box-shadow: 0 0 10px rgba(47, 181, 78, 0.6);
        animation: pulse 1.5s infinite;
      }
    }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(47, 181, 78, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(47, 181, 78, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(47, 181, 78, 0);
  }
}

.select-box {
  padding: 0px 15px;
  background-color: #353535;
  color: #dbdbdb;
  border-radius: 4px;
  line-height: 32px;
  height: 32px;
  cursor: pointer;
  user-select: none;
  position: relative;
  i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    margin-top: -12px;
    rotate: 180deg;
  }
}
</style>
<style lang="less">
.region-map {
  &.el-popover {
    padding: 0;
    border: none;
    border-radius: 4px;
    background-color: #353535;
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  }
}
</style>
